import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Persons from './Persons.vue'
import Person from './Person.vue'
import AppHeader from '../../components/layout/Header'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/persons',
      name: 'Persons',
      components: {
        default: Persons,
        header: AppHeader
      },
      meta: {
        dontShowInMenu: true
      },
      beforeEnter: allowOnlyAuthorized()
    },
    {
      path: '/persons/:personId',
      name: 'Person',
      components: {
        default: Person,
        header: AppHeader
      },
      meta: {
        dontShowInMenu: true,
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
